import { render, staticRenderFns } from "./SwitcherRow.vue?vue&type=template&id=c181b600&"
import script from "./SwitcherRow.vue?vue&type=script&lang=js&"
export * from "./SwitcherRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports